import { cn } from '@/lib/cn';

/**
 * The OG Meridian International mark: gold meridian on the warm near-black
 * tile. Identical in both themes.
 */
export function BrandMark({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-grid place-items-center rounded bg-tile', className)}
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 2000 2010" width={size * 0.78} height={size * 0.78}>
        <g fill="none" stroke="#C9A84C" strokeWidth="120">
          <circle cx="1000" cy="1003" r="880" />
          <path d="M1000 123v1760" />
          <path d="M1000 170L1450 1003L1000 1836L550 1003Z" />
          <path d="M120 1003h430M1450 1003h430" />
        </g>
      </svg>
    </span>
  );
}
